import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    method: String
  }


  connect() {
    console.log("AI Survey controller connected")
    this.spinnerContainer = document.querySelector('#loadSpinner')
  }

  generate(event) {
    event.preventDefault()
    this.startLoading()
    const button = event.currentTarget
    button.disabled = true

    fetch(this.urlValue, {
      method: this.methodValue,
      headers: {
        "X-CSRF-Token": this.getMetaValue("csrf-token"),
        "Accept": "application/json"
      },
      credentials: "same-origin"
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        console.log('AI survey generation response:', data)

        this.handleSuccess(data, button)
      })
      .catch(error => {
        this.handleError(error, button)
      })
  }

  startLoading() {
    // Use a class variable that's properly initialized in connect()
    if (this.spinnerContainer) {
      this.spinnerContainer.style.display = 'inline-block'
    }
  }

  handleSuccess(data, button) {
    // Re-enable the button
    // button.disabled = false
    button.textContent = this.t(".show_survey") || "Перейти к опросу"
    if (this.spinnerContainer) {
      this.spinnerContainer.style.display = 'none'
    }

    if (data.status === "success") {
      // Success message
      this.showToast("success", data.message || this.t("ai.successfully_generated_questions"))

      // Reload the page after a brief delay
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    } else {
      // Error message
      this.showToast("error", data.message || this.t("ai.failed_generated_questions"))
    }
  }

  handleError(error, button) {
    console.error("Error generating AI survey:", error)

    // Re-enable the button
    button.disabled = false
    button.textContent = this.t("generate") || "Generate"

    // Show error message
    this.showToast("error", this.t("ai.failed_generated_questions"))
  }

  showToast(type, message) {
    if (window.toastr) {
      window.toastr[type](message)
    } else {
      alert(message)
    }
  }

  getMetaValue(name) {
    const element = document.querySelector(`meta[name="${name}"]`)
    return element ? element.getAttribute("content") : ""
  }

  t(key) {
    return window.t ? window.t(key) : ""
  }
}